module.exports = __webpack_public_path__ + "static/img/fortnox.7ff24ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fortnox.png
// module id = A9nF
// module chunks = 1